export default __webpack_public_path__ + "static/media/news73.ba65d989.jpg";